import { render, staticRenderFns } from "./InterviewCoach.vue?vue&type=template&id=08e13633&scoped=true&"
import script from "./InterviewCoach.vue?vue&type=script&lang=js&"
export * from "./InterviewCoach.vue?vue&type=script&lang=js&"
import style0 from "./InterviewCoach.vue?vue&type=style&index=0&id=08e13633&scoped=true&lang=css&"
import style1 from "../../css/newProjectDetail.css?vue&type=style&index=1&id=08e13633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e13633",
  null
  
)

export default component.exports